<template>
    <div class="container">
        <!-- -->
        <div class="mail-verif-wrapper elevation-5">
            <div class="hmi-cross">
                <img src="../../../assets/HMLOGO_WHITE.webp" alt="">
            </div>
            <div class="noti-content-wrapper">
                <div class="mail-svg">
                    <img src="../../../assets/mail-box.svg" alt="">
                </div>
                <div class="noti">
                    <h2>An Email has been sent!</h2>
                    <h3>
                        A reset link is sent to
                        <strong>{{ data.email }}</strong> to reset your password
                        and to fully use your account.
                    </h3>
                    <h4>
                        Didn't receive any mail? Check your spam folder or
                        <a href=""></a>
                        <v-btn
                            small
                            class="font-weight-bold"
                            text
                            :disabled="btn_disabled"
                            @click="
                                recoverPass(),
                                btnSleep()
                            "
                        >
                            Click here
                        </v-btn>
                        to resend your activation link.
                        <br>
                    </h4>
                    <span v-if="btn_disabled">
                        Please wait for <span style="color: red;">{{ timer }}</span>s before resending the recovery link again.
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    props: ['data'],
    data: () => ({
        showPage: null,
        url: 'https://www.google.com',
        btn_disabled: false,
        timer: 100
    }),
    computed: {
        ...mapGetters(['providerForgotPassword'])
    },
    watch: {
        providerForgotPassword(newVal) {
            if (newVal.status!==200) this.$router.push('/')
        }
    },
    beforeDestroy() {
        this.$emit('clearProviderData')
    },
    methods: {
        ...mapActions(['getCsrfToken', 'forgotPassword']),
        async recoverPass() {
            await this.forgotPassword({ EMAIL:this.data.email,USERNAME:this.data.username })
        },
        btnSleep() {
            this.btn_disabled = true
            this.timer = 100
            const interval = setInterval(() => {
                this.timer -= 1
                if (this.timer == 0) {
                    this.btn_disabled = false
                    clearInterval(interval)
                }
            }, 1000)
        }
    }
}
</script>

<style scoped>
.container {
  /* background-image: url("../../../assets/loginBG.webp"); */
  /* background-position: center;
  background-size: cover; */
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}
h2 {
  font-size: 45px;
  padding: 15px 0px;
}
h3 {
  width: 90%;
  margin: auto;
  font-weight: normal;
}
h4 {
  width: 90%;
  margin: auto;
  padding: 20px 0px;
}
/* Main wrapper */
.hmi-cross {
  position: absolute;
  width: 12%;
  top: 2%;
  left: 1%;
}

.hmi-cross img {
  width: 100%;
}
.mail-verif-wrapper {
  position: relative;
  background-image: url("../../../assets/mail-bg-wrapper.webp");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background-color: white;
  border-radius: 100px 0px 100px 0px;
  width: 70%;
  height: 70%;
}

.mail-svg {
  width: 35%;
  font-size: 12px;
  margin: auto;
}
.mail-svg img {
  width: 50%;
}
.noti-content-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  height: 90%;
  text-align: center;
}

.noti {
  width: 90%;
  margin: auto;
}

@media (max-width: 599px) {
  .mail-verif-wrapper {
    height: 90%;
    width: 90%;
    background-position: left;
    border-radius: 30px 0px 30px 0px;
  }
  .noti-content-wrapper {
    width: 100%;
    height: 85%;
    bottom: 1%;
  }
  .noti {
    width: 90%;
  }
  .mail-svg {
    width: 55%;
  }
  .hmi-cross {
    width: 35%;
    left: 5%;
  }

  h2 {
    font-size: 28px;
  }
  h3 {
    font-size: 18px;
    padding: 15px 0px;
  }
  h4 {
    font-size: 15px;
  }
}
@media (min-width: 599px) and (max-width: 960px) {
  .mail-verif-wrapper {
    height: 70%;
    width: 90%;
    border-radius: 60px 0px 60px 0px;
  }
  .noti-content-wrapper {
    width: 100%;
    height: 70%;
    bottom: 5%;
  }
  .noti {
    width: 80%;
  }
  .hmi-cross {
    width: 20%;
    left: 5%;
  }
  .mail-svg {
    width: 40%;
  }
  h2 {
    font-size: 40px;
  }
  h3 {
    padding: 15px 0px;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .mail-verif-wrapper {
    height: 70%;
    width: 90%;
    border-radius: 60px 0px 60px 0px;
  }
  .noti-content-wrapper {
    width: 100%;
    height: 70%;
    bottom: 10%;
  }
  .noti {
    width: 80%;
  }
  .hmi-cross {
    width: 20%;
    left: 5%;
  }
  .mail-svg {
    width: 40%;
  }
  h2 {
    font-size: 40px;
  }
  h3 {
    padding: 15px 0px;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .mail-verif-wrapper {
    height: 70%;
    width: 90%;
    border-radius: 60px 0px 60px 0px;
  }
  .noti-content-wrapper {
    width: 100%;
  }
  .noti {
    width: 50%;
  }
  .mail-svg {
    width: 25%;
  }
  h2 {
    font-size: 40px;
  }
  h3 {
    padding: 15px 0px;
  }
}
</style>
